import { ECOM_VERSION } from './version';

const apiScope: string = 'api://ECOMEcus.onmicrosoft.com/Ecom.Api/Ecom.Api';

export const environment = {
  production: true,
  version: ECOM_VERSION,
  apiHost: 'https://api.ecus.se/',
  statNrApiHost: 'https://api.ecus.se/',
  windowProxy: 'https://api.ecus.se/proxy',
  windowOrigin: 'https://ecom.ecus.se',
  signalR: {
    url: 'https://api.ecus.se/ecom'
  },
  timezone: 'Europe/Stockholm',
  defaultDateMoment: 'yyyy-MM-dd HH:mm',
  onlyDateMoment: 'yyyy-MM-dd',
  maxFileSize: 20971520, // 20 MiB
  sentry: {
    dsn:
      'https://942b76b925724465b124a4d82b01a595@o509176.ingest.sentry.io/5753892',
    environment: 'production',
    tracingOrigins: ['api.ecus.se'],
    tracesSampleRate: 0.2
  },
  auth: {
    clientId: '310ae3cf-fa73-47c0-8aac-0309c39155e7',
    authority: 'https://login.microsoftonline.com/999bba2a-0569-4f11-a840-cb101afbb3ac',
    redirectUri: 'https://ecom.ecus.se',
    apiScope: apiScope,
    scopes: ['user.read', apiScope]
  }
};
